// Single source of truth for EDUJAC legal/company information.
// Update the [TO BE UPDATED] values HERE once registration details are available —
// every legal page reads from this file.
export const COMPANY = {
  brand: "EDUJAC",
  legalName: "EDUJAC Technologies LLP",
  website: "https://edujac.com",
  websiteDisplay: "edujac.com",
  // Preferred once the mailboxes are confirmed live: privacy@edujac.com / support@edujac.com
  privacyEmail: "[TO BE UPDATED]",
  supportEmail: "[TO BE UPDATED]",
  registeredOffice: "[TO BE UPDATED]",
  llpin: "[TO BE UPDATED]",
  gstin: "[TO BE UPDATED]",
  grievanceOfficer: "[TO BE UPDATED]",
  phone: "[TO BE UPDATED]",
  jurisdiction: "[TO BE UPDATED]",
  lastUpdated: "28 August 2026",
};
